import { ModelResource } from './resource';
import { DisputeReason } from '../models';

export class DisputeReasons extends ModelResource<DisputeReason> {
  model = DisputeReason;

  resourcePath = 'v1/dispute-reasons';

  addSuggestions(codes: string[]) {
    return this.api.post(this.path('add-suggested'), { data: { codes } });
  }

  async archive(id: string, disputeReason: DisputeReason) {
    const response = await super.update(id, { data: { is_active: false } });

    disputeReason.updateFromJson(response);

    return response;
  }

  async restore(id: string, disputeReason: DisputeReason) {
    const response = await super.update(id, { data: { is_active: true } });

    disputeReason.updateFromJson(response);

    return response;
  }

  suggested() {
    return this.api.get(this.path('suggested'));
  }
}
